import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ITaskDraft, TaskDraft } from '@core/entities/task/TaskDraft'

const taskTransform: (task: ITaskDraft) => TaskDraft = (data) => {
  return TaskDraft.new(data)
}

export const useTaskDraftById = (
  payload: RequestTypes['getTaskDraft'],
  options?: UseQueryOptions<ITaskDraft, RequestErrorType, TaskDraft>,
) => {
  return useQuery({
    select: taskTransform,
    ...taskKeys.draftById(payload),
    ...options,
  })
}
